import { Gender } from './gender-cookie-service.types';

export const GENDER_COOKIE_CHANGED_EVENT = 'genderCookieChanged';

export const GENERIC_FEMALE_PATHS = ['ladies'];
export const GENERIC_MALE_PATHS = ['men', 'mens'];

export const DEFAULT_GENDER: Gender = 'female';
export const SEARCH_GENDERS: Gender[] = ['female', 'male'];
export const MIN_GENDERS_FOR_ENABLING_GENDER_FEATURES = 2;
